import { z } from "zod";
export const JoinEventRequestSchema = z.object({
    joinCode: z.string().min(1).max(20),
});
